import axios from "axios";
import apis from "./index";

export const getUserByEmail = async (email, token) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    method: "GET",
    url: `${apis.getUser.byEmail}?email=${encodeURIComponent(email)}`,
    headers,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("getUserByEmail Error:", error);
    throw error;
  }
};

export const getAllUsers = async (params, token) => {
  const { page = 1, limit = 10, search = "" } = params;
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  // Construct query parameters
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);
  if (search) queryParams.append("search", search);

  const config = {
    method: "GET",
    url: `${apis.getUser.all}?${queryParams.toString()}`,
    headers,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("getAllUsers Error:", error);
    throw error;
  }
};
